/* eslint-disable global-require */
/* eslint-disable no-console */

import React from 'react';
import _ from 'lodash';
import gatewayFetch from '../../../../../appModules/utilities/gatewayFetch';
import http from 'superagent';
import appConfig from '../../../../../appConfig/AppConfig';
import styles from './css/EntryNav.styl';
import {
  bindMethods,
  setRef,
  getMediaType,
  getMediaExtension,
} from '../../../../shared/utilities/componentHelpers';
import {VIDEO_INPUT} from '../../../../shared/utilities/constants';
import {VIDDLER_AUTH_QUERY} from '../../../../redux/templates/queryTemplates';
import {
  AddPhotoIcon,
  AddVideoIcon,
  LightCandleIcon,
} from '../../../../shared/Svgs';
import {scrollToTop} from '../../../../shared/utilities/scrollHelpers';

const conf = appConfig();

/**
 * The navigation buttons for the condolence entry
 * @param   {object}  props - passed down props
 * @return  {JSX}     returns the entry navigation
 */
export default class EntryNav extends React.Component {
  static propTypes = {
    allowGuestBookPhoto: React.PropTypes.bool,
    allowGuestBookVideo: React.PropTypes.bool,
    allowGuestBookCandle: React.PropTypes.bool,
    fpData: React.PropTypes.object,
    handleCandleToggle: React.PropTypes.func,
    handleDisplayError: React.PropTypes.func,
    handleEditOverlay: React.PropTypes.func,
    handleMediaCollection: React.PropTypes.func,
    handlePendingUpload: React.PropTypes.func,
    isCandleLit: React.PropTypes.bool,
    isInferiorBrowser: React.PropTypes.bool,
    location: React.PropTypes.object,
    mediaCollection: React.PropTypes.array,
    mobileDetails: React.PropTypes.object.isRequired,
  };

  static defaultProps = {
    allowGuestBookPhoto: false,
    allowGuestBookVideo: false,
    allowGuestBookCandle: true,
  };

  constructor(props) {
    super(props);

    const debug = _.get(props, 'location.query.debug');

    this.filepicker = this.getFilePicker(debug);
    this.scrollPosition = 0;
    this.pictures = [];
    this.setVideoInputRef = _.partial(setRef, _, VIDEO_INPUT, this);
    this.viddlerUploadData = null;
    this.fpPolicy = _.get(props, 'fpData.fpPolicy', null);
    this.fpSignature = _.get(props, 'fpData.fpSignature', null);
    this.videoFormats =
      '.mp4,.m4v,h.264,.avi,.mov1,.mov,.wmv,.wmv9,.mpg,.mpeg,.m2v,.mpeg-1,.mpeg-2,.mkv';

    bindMethods(this, [
      'createUploadDialog',
      'onVideoAdd',
      'togglePhotoUpload',
    ]);
  }

  /* picture upload methods */

  /**
   * Creates filepicker instance or returns existing one
   * @param  {number} debug the query param to disable ads and 3rd party scripts
   * @return {class}  filepicker instance
   */
  getFilePicker(debug) {
    if (typeof window !== 'undefined' && debug !== '3' && debug !== '4') {
      require('filepicker-js');
      window.filepicker.setKey(conf.filepicker.key);
      return window.filepicker;
    }
  }

  /**
   * Complete hack for filestack overlay on phones
   * @param  {number} [y=0] y Position of scroll
   * @return {undefined}       Returns nothing
   */
  scrollTo(y = 0) {
    if (this.props.mobileDetails.apple.device) {
      const element = this.props.isInferiorBrowser
        ? document.documentElement
        : document.body;

      element.style.position = 'fixed';
      element.style.width = '100%';

      const scrollSpeed = 500;

      scrollToTop(element, y, scrollSpeed);
    }
  }

  /**
   * Parses filepicker data and adds creds and id
   * @param  {array}      filePickerResponse filepicker data
   * @return {undefined}  Returns nothing
   */
  handlePickComplete(filePickerResponse) {
    const urls = JSON.parse(filePickerResponse);
    const credentials =
      this.fpPolicy && this.fpSignature
        ? `?policy=${this.fpPolicy}&signature=${this.fpSignature}`
        : '';

    const pictures = urls.map(picture =>
      new Promise((resolve, reject) => {
        const pictureOutput = picture;

        pictureOutput.fileExtension = getMediaExtension(picture.mimetype);
        pictureOutput.id = _.last(picture.url.split('/'));
        pictureOutput.mediaType = getMediaType(picture.mimetype);
        pictureOutput.url = `${picture.url}${credentials}`;

        this.filepicker.convert(
          picture,
          {
            format: 'jpg',
            rotate: 'exif',
          },
          convertedPicture => {
            pictureOutput.fileExtension = getMediaExtension(
              convertedPicture.mimetype
            );
            pictureOutput.filename = convertedPicture.filename;
            pictureOutput.id = _.last(convertedPicture.url.split('/'));
            pictureOutput.isWriteable = convertedPicture.isWriteable;
            pictureOutput.mediaType = getMediaType(convertedPicture.mimetype);
            pictureOutput.mimetype = convertedPicture.mimetype;
            pictureOutput.size = convertedPicture.size;
            pictureOutput.url = `${convertedPicture.url}${credentials}`;

            this.filepicker.stat(
              convertedPicture,
              {
                width: true,
                height: true,
              },
              dimensions => {
                pictureOutput.height = dimensions.height;
                pictureOutput.width = dimensions.width;

                resolve(pictureOutput);
              },
              err => {
                reject(err);
              }
            );
          },
          err => {
            reject(err);
          }
        );
      }).catch(reason => {
        console.log('error with filepicker `stat` or `convert`', reason);
        return {};
      })
    );

    this.props.handleMediaCollection(pictures, true, this.scrollPosition);
  }

  /**
   * Uploads files to filepickers's api, sets CondolenceEntry's pictures state
   * @param  {array}      mimetype   the allowed file type(s) i.e. 'image/*'
   * @param  {array}      services   outside services to pick files from i.e. ['COMPUTER', 'FACEBOOK', 'CLOUDAPP']
   * @param  {string}     container  the filepicker popup type: 'modal' or 'window'
   * @return {undefined}  Retruns nothing
   */
  handlePick(mimetype, services, container = 'modal') {
    const options = {
      mimetype,
      services,
      container,
    };

    const {fpPolicy, fpSignature} = this.props.fpData || {};

    if (fpPolicy && fpSignature) {
      options.policy = fpPolicy;
      options.signature = fpSignature;
    }

    if (_.isFunction(_.get(this, 'filepicker.pickMultiple'))) {
      this.filepicker.pickMultiple(
        options,
        blob => {
          this.pictures.push(JSON.stringify(blob));
          this.handlePickComplete(this.pictures[0]);
        },
        fpError => {
          if (fpError.code !== 101) {
            this.props.handleDisplayError('picturesUpload');
          }
          this.props.handleMediaCollection([], false, this.scrollPosition);
        }
      );
    } else {
      this.props.handleDisplayError('picturesUnavailable');
    }

    this.scrollPosition = window.pageYOffset;
    this.scrollTo(0);
  }

  /**
   * Toggle the photo upload menu - sets the media upload state
   * @method  togglePhotoUpload
   * @return  {undefined} Returns nothing
   */
  togglePhotoUpload() {
    this.pictures = [];
    this.props.handleDisplayError();
    this.handlePick(
      ['image/*'],
      ['COMPUTER', 'FACEBOOK', 'FLICKR', 'INSTAGRAM', 'PICASA']
    );
  }

  /* video upload methods */

  /**
   * Makes an ajax request to the gateway
   * to get the viddler upload endpoint and token
   * @method requestViddlerAuth
   * @return {undefind} returns the viddler auth information
   */
  requestViddlerAuth() {
    return gatewayFetch(VIDDLER_AUTH_QUERY, 'query')
      .then(res => {
        this.viddlerUploadData = _.get(res, 'data.video');

        return this.viddlerUploadData;
      })
      .catch(err => {
        console.log('error getting viddler auth', err);
        return err;
      });
  }

  /**
   * Creates the system dialog via a simulated click on the hidden input element
   * At this point we know a user wants to do a video upload so we request the auth
   * @method createUploadDialog
   * @return {undefined} returns nothing
   */
  createUploadDialog() {
    this.props.handleDisplayError();
    this.requestViddlerAuth();
    this[VIDEO_INPUT].click();
  }

  /**
   * Uploads a video to viddler
   * @method uploadVideo
   * @param  {string}    viddlerUrl endpoint to make the POST
   * @param  {string}    token      viddler auth token
   * @return {undefined} returns nothing, fires handleVideoUploadComplete on success
   */
  uploadVideo(viddlerUrl, token) {
    const file = this[VIDEO_INPUT].files[0];

    this.props.handlePendingUpload('Loading', null);
    return http
      .post(viddlerUrl)
      .field('name', file.name)
      .field('uploadtoken', token)
      .attach('file', file)
      .then(res => {
        if (res.error) {
          this.props.handlePendingUpload(false, null);
          console.log('error response from viddler', res.error);
        } else {
          this.props.handlePendingUpload(
            false,
            this.handleVideoUploadComplete(res, file)
          );
        }
      })
      .catch(() => {
        // the error will be displayed in handlePendingUpload
        this.props.handlePendingUpload(false, null);
      });
  }

  /**
   * Listener on the video input, upon
   * @method onVideoAdd
   * @return {undefined} returns nothing, fires the viddler upload
   */
  onVideoAdd() {
    if (_.isObject(this.viddlerUploadData)) {
      const {endpoint, token} = this.viddlerUploadData;

      this.uploadVideo(endpoint, token);
    } else {
      this.props.handleDisplayError('video');
    }
  }

  /**
   * Processes the payload from viddler and fires handleMediaCollection
   * @method handleVideoUploadComplete
   * @param  {object}     viddlerResponse parsed response from viddler upload
   * @param  {object}     file            information about the video file
   * @return {undefined}  returns nothing, fires handleMediaCollection (GuestBook)
   */
  handleVideoUploadComplete(viddlerResponse, file) {
    const payload = JSON.parse(viddlerResponse.text);
    const videoData = _.get(payload, 'video', null);

    if (_.isObject(videoData)) {
      const mimetype = _.get(file, 'type', 'video/');
      const media = {
        id: videoData.id,
        url: videoData.thumbnail_url,
        mimetype,
        filename: _.get(file, 'name', 'video'),
        mediaType: getMediaType(mimetype),
        fileExtension: getMediaExtension(mimetype),
      };

      this.props.handleMediaCollection([media], true);
    } else {
      this.props.handleDisplayError('video');
    }
  }

  render() {
    const {
      allowGuestBookPhoto,
      allowGuestBookVideo,
      allowGuestBookCandle,
      handleEditOverlay,
      mediaCollection,
      isCandleLit,
      handleCandleToggle,
    } = this.props;
    const collectionSize = _.size(mediaCollection);

    let display = null;
    const mediaType = _.get(_.head(mediaCollection), 'mediaType', 'Item');

    if (collectionSize !== 0) {
      const mediaString = collectionSize > 1 ? `${mediaType}s` : `${mediaType}`;

      display = (
        <div className={styles.EntryNav}>
          <span className={styles.removeAll} onClick={handleEditOverlay}>
            {`Edit ${mediaString}`}
          </span>
        </div>
      );
    } else if (isCandleLit) {
      display = (
        <div className={styles.EntryNav}>
          <span className={styles.removeAll} onClick={handleCandleToggle}>
            Remove Candle
          </span>
        </div>
      );
    } else if (this.props.handleMediaCollection) {
      display = (
        <div className={styles.EntryNav}>
          <div className={styles.uploadButtons}>
            {allowGuestBookPhoto ? (
              <button className={styles.photo} onClick={this.togglePhotoUpload}>
                <AddPhotoIcon />
              </button>
            ) : null}
            {allowGuestBookCandle ? (
              <button className={styles.candle} onClick={handleCandleToggle}>
                <LightCandleIcon />
              </button>
            ) : null}
          </div>
          <input
            accept={this.videoFormats}
            id="videoupload"
            onChange={this.onVideoAdd}
            ref={this.setVideoInputRef}
            style={{display: 'none'}}
            type="file"
          />
        </div>
      );
    }

    return display;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/EntryNav.js